// 음원 관리 공통 유틸리티 함수

// HR 레벨 옵션 (공통)
export const HR_LEVEL_OPTIONS = [
	{ value: 1, text: "HI" },
	{ value: 2, text: "MID" },
	{ value: 3, text: "LOW" }
];

// 활성화 옵션 (공통)
export const ACTIVE_OPTIONS = [
	{ value: true, text: "노출" },
	{ value: false, text: "미노출" }
];

// 정렬 옵션 (공통)
export const SORT_OPTIONS = [
	{ value: "updated", text: "수정일순" },
	{ value: "created", text: "생성일순" },
	{ value: "title", text: "제목순" },
	{ value: "category", text: "카테고리순" },
	{ value: "active", text: "노출상태순" },
	{ value: "level", text: "레벨순" }
];

// HR 레벨 텍스트 (공통)
export function getHRLevelText(levelValue) {
	const levels = {
		1: "HI",
		2: "MID",
		3: "LOW"
	};
	return levels[levelValue] || "";
}

// HR 레벨 배경색 (공통)
export function getHRLevelBgColor(levelValue) {
	const colors = {
		1: "bg-primary bg-opacity-25",
		2: "bg-success bg-opacity-25", 
		3: "bg-warning bg-opacity-25"
	};
	return colors[levelValue] || "bg-secondary bg-opacity-10";
}

// HR 레벨 테두리 색상 (공통)
export function getHRLevelBorderColor(levelValue) {
	const colors = {
		1: "border-primary",
		2: "border-success",
		3: "border-warning"
	};
	return colors[levelValue] || "border-secondary";
}

// HR 레벨 배지 색상 (공통)
export function getHRLevelBadgeColor(levelValue) {
	const colors = {
		1: "bg-primary",
		2: "bg-success", 
		3: "bg-warning"
	};
	return colors[levelValue]
		? `${colors[levelValue]} text-dark fw-bold border border-dark`
		: "bg-secondary text-dark border border-dark";
}

// 음원 ID 생성 (공통 로직)
export function generateMusicId(categoryId, hrLevel, lastNumber = 0) {
	const baseNumber = categoryId * 10000 + hrLevel * 1000;
	return baseNumber + (lastNumber + 1);
}

// 이미지 URL 생성 (공통)
export function getImageUrl(imagePath, getResourceUrl) {
	if (!imagePath) return "";
	if (imagePath.startsWith("http") || imagePath.startsWith("data:")) {
		return imagePath;
	}
	return getResourceUrl(imagePath);
}

// 이미지 에러 처리 (공통)
export function handleImageError(e) {
	console.error("이미지 로드 실패:", e.target.src);
	e.target.src = "/assets/img/nope-not-here.avif";
	e.target.alt = "이미지를 찾을 수 없습니다";
} 